import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

interface Manager {
  name: string;
  email: string;
}

interface ManagerSectionProps {
  managers: Manager[];
  onChange: (managers: Manager[]) => void;
}

export const ManagerSection: React.FC<ManagerSectionProps> = ({
  managers,
  onChange,
}) => {
  const addManager = () => {
    onChange([...managers, { name: '', email: '' }]);
  };

  const removeManager = (index: number) => {
    const updated = managers.filter((_, i) => i !== index);
    onChange(updated);
  };

  const updateManager = (index: number, field: keyof Manager, value: string) => {
    const updated = managers.map((manager, i) =>
      i === index ? { ...manager, [field]: value } : manager
    );
    onChange(updated);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-700">
          Gerentes
        </label>
        <button
          type="button"
          onClick={addManager}
          className="inline-flex items-center gap-1 px-3 py-1 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          aria-label="Adicionar gerente"
        >
          <Plus className="w-4 h-4" />
          <span>Adicionar</span>
        </button>
      </div>

      {managers.length === 0 && (
        <p className="text-sm text-gray-500 italic">Nenhum gerente cadastrado</p>
      )}

      {managers.map((manager, index) => (
        <div
          key={index}
          className="p-4 border border-gray-200 rounded-lg bg-gray-50 space-y-3"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Nome do Gerente
                </label>
                <input
                  type="text"
                  value={manager.name}
                  onChange={(e) => updateManager(index, 'name', e.target.value)}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Digite o nome do gerente"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  E-mail
                </label>
                <input
                  type="email"
                  value={manager.email}
                  onChange={(e) => updateManager(index, 'email', e.target.value)}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Digite o e-mail"
                />
              </div>
            </div>
            <button
              type="button"
              onClick={() => removeManager(index)}
              className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              aria-label={`Remover gerente ${index + 1}`}
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};